import { BaseService } from '../base';
import type { CommissionLimits } from './types';

export class CommissionLimitsService extends BaseService {
  private customBaseUrl = import.meta.env.VITE_API_URL;

  constructor() {
    super();
  }

  async getCommissionLimits(
    productCode: string,
    versionDate: string
  ): Promise<{
    success: boolean;
    data?: CommissionLimits;
    error?: string;
  }> {
    try {
      const path = `/portal/v1/products/${productCode}/commission-limits?versionDate=${encodeURIComponent(versionDate)}`;
      const response = await this.get(path, {}, this.customBaseUrl);
      return this.handleJsonResponse<CommissionLimits>(response);
    } catch (error) {
      return {
        success: false,
        error:
          error instanceof Error
            ? error.message
            : 'Erro ao carregar limites de comissão',
      };
    }
  }
}

export const commissionLimitsService = new CommissionLimitsService();
export type { CommissionLimits } from './types';
